var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "low-risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GloepidOne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "low-risk",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon-BG",
    fill: "#BBE5B3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polaris-icon/Major/2-Tone/Circle-Tick",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Fill",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M12.293,7.293 L9,10.586 L7.707,9.293 C7.316,8.902 6.684,8.902 6.293,9.293 C5.902,9.684 5.902,10.316 6.293,10.707 L8.293,12.707 C8.488,12.902 8.744,13 9,13 C9.256,13 9.512,12.902 9.707,12.707 L13.707,8.707 C14.098,8.316 14.098,7.684 13.707,7.293 C13.316,6.902 12.684,6.902 12.293,7.293",
    id: "Mask",
    fill: "#108043"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.91fb74711ec6b9ee05d7f82cd83b6701.svg";
export { ForwardRef as ReactComponent };